/* melee-v2-weight-chart.js — migrated out of sections/melee-v2-weight-chart.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    /* ---- weight chart: build the axis ticks, place the UCI line, and
       grow + count up the bars the first time the chart scrolls in ---- */
    function initWchart(root) {
      if (!root || root.dataset.mv2WchartReady === '1') return;
      root.dataset.mv2WchartReady = '1';

      var CONFIG = {
        uci: parseFloat(root.dataset.uci) || 6.8,
        axisMin: parseFloat(root.dataset.axisMin) || 6.4,
        axisMax: parseFloat(root.dataset.axisMax) || 7.3,
        tickStep: parseFloat(root.dataset.tickStep) || 0.1,
        duration: 900, // per-bar grow/count duration (ms)
        stagger: 80, // delay between rows (ms)
      };

      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wrap = root.querySelector('[data-mv2-wchart-wrap]');
      var axis = root.querySelector('[data-mv2-wchart-axis]');
      var bars = Array.prototype.slice.call(root.querySelectorAll('[data-mv2-wchart-bar]'));
      if (!wrap || !axis) return;

      var clamp = function (v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      };
      var easeOutCubic = function (t) {
        return 1 - Math.pow(1 - t, 3);
      };
      var pos = function (v) {
        return clamp((v - CONFIG.axisMin) / (CONFIG.axisMax - CONFIG.axisMin));
      };

      // place the UCI line
      wrap.style.setProperty('--uci', pos(CONFIG.uci).toFixed(4));

      // build the value axis ticks
      var steps = Math.round((CONFIG.axisMax - CONFIG.axisMin) / CONFIG.tickStep);
      for (var i = 0; i <= steps; i++) {
        var val = CONFIG.axisMin + i * CONFIG.tickStep;
        var tick = document.createElement('div');
        tick.className =
          'mv2-wchart__tick' + (i === 0 ? ' mv2-wchart__tick--first' : i === steps ? ' mv2-wchart__tick--last' : '');
        tick.style.left = (pos(val) * 100).toFixed(2) + '%';
        tick.innerHTML =
          '<span class="mv2-wchart__tick-mark"></span><span class="mv2-wchart__tick-val">' + val.toFixed(1) + '</span>';
        axis.appendChild(tick);
      }

      // decimal places to DISPLAY come from how each value was actually
      // entered (e.g. "6.65" -> 2, "6.647" -> 3, "7" -> 0) — never forced
      // to a fixed 2, so the real value's own precision is never rounded away
      function decimalsOf(b) {
        var raw = b.getAttribute('data-value') || '';
        var dot = raw.indexOf('.');
        return dot === -1 ? 0 : raw.length - dot - 1;
      }

      // start collapsed
      bars.forEach(function (b) {
        b.style.width = '0%';
        var num = b.querySelector('.mv2-wchart__num');
        if (num) num.textContent = (0).toFixed(decimalsOf(b));
      });

      function setFinal() {
        bars.forEach(function (b) {
          var v = parseFloat(b.dataset.value);
          b.style.width = (pos(v) * 100).toFixed(2) + '%';
          var num = b.querySelector('.mv2-wchart__num');
          if (num) num.textContent = v.toFixed(decimalsOf(b));
        });
      }

      function play() {
        var start = performance.now();
        function frame(now) {
          var done = true;
          bars.forEach(function (b, i) {
            var v = parseFloat(b.dataset.value);
            var t = clamp((now - start - i * CONFIG.stagger) / CONFIG.duration);
            var e = easeOutCubic(t);
            b.style.width = (e * pos(v) * 100).toFixed(2) + '%';
            var num = b.querySelector('.mv2-wchart__num');
            if (num) num.textContent = (e * v).toFixed(decimalsOf(b));
            if (t < 1) done = false;
          });
          if (done) {
            setFinal();
            return;
          }
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }

      if (reduce) {
        setFinal();
        return;
      }

      // fire once, the first time the chart scrolls into view
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              io.disconnect();
              play();
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-wchart]').forEach(initWchart);
    }

    ready(initAll);
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-mv2-wchart]') : null;
      if (root) {
        root.dataset.mv2WchartReady = '0';
        initWchart(root);
      }
    });
  })();

  /* The shared MV2 scroll-fx engine (the driver behind .mv2-reveal--fade /
     .mv2-parallax) that used to live here has moved to
     melee-v2-foundation.liquid's inline <script>, rendered once by every
     melee-v2- section instead of being duplicated per file. This file now
     only carries the bar-chart animation logic above. */
